import { Observable } from 'rxjs';
import { NewsList } from '../../model/news.model';

export abstract class NewsAdapter {
  abstract load(start: number, count: number): Observable<NewsList>;
  abstract loadByType(start: number, count: number, newsType: string): Observable<NewsList>;
  abstract loadByYear(start: number, count: number, newsYear: string): Observable<NewsList>;
  abstract loadByTypeAndYear(start: number, count: number, newsType: string, newsYear: string): Observable<NewsList>;
}
